export default {
    install (_Vue) {
        _Vue.mixin({
            beforeDestroy () {
                this.$wx.hideToast()
                this.$wx.hidePreviewImage()
            }
        })
    }
}
